import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as common from '../../common'

import * as gql from './gql'
import * as models from './models'

@ngCore.Injectable({ providedIn: 'root' })
export class Api {
  /**
   * Returns a list of {@link models.User} objects filtered by
   * {@link models.User.Filter}.
   */
  public listUsers(
    filters?: models.User.Filters,
  ): rxjs.Observable<readonly models.User[]> {
    if (!filters?.context) {
      return gql.queries.users
        .execute()
        .pipe(rxjs.map(response => response.items))
    }

    const appId = 'appId' in filters.context ? filters.context.appId : undefined
    const tenantId = filters.context.tenantId
    const zoneId =
      'zoneId' in filters.context ? filters.context.zoneId : undefined

    return (
      appId && zoneId && tenantId
        ? gql.queries.inApp.execute({
            appId,
            tenantId,
            zoneId,
          })
        : zoneId && tenantId
          ? gql.queries.inZone.execute({
              tenantId,
              zoneId,
            })
          : tenantId
            ? gql.queries.inTenant.execute({
                tenantId,
              })
            : gql.queries.users.execute()
    ).pipe(rxjs.map(response => response.items))
  }

  /**
   * Manages the assignment of agent access to users
   */
  public assignAgentAccess(
    assignments: readonly ents.core.admin.Access.Assignment[],
  ): rxjs.Observable<boolean | undefined> {
    return gql.mutations.assignAgentAccess.executor({
      assignments: assignments.map(assignment => ({
        ...assignment,
        agentId: assignment.agentId
          ? common.gql.enums.agentId.TRANSFORMER.getGqlFrom(assignment.agentId)
          : undefined,
        excludePages: assignment.excludePages
          ? Array.from(assignment.excludePages)
          : undefined,
        includePages: assignment.includePages
          ? Array.from(assignment.includePages)
          : undefined,
      })),
    })
  }
}
